<template>
	<div class="grid-flex-container">
		<div class="grid-toolbar">
			<v-tabs v-model="tab" @change="onTabItemChanged">
				<v-tab v-for="(item, index) in items" :key="index">{{
					item.Name
				}}</v-tab>
			</v-tabs>
		</div>
		<v-card flat class="flex-grow-1 mt-0 overflow-y-hidden">
			<admin-user-management v-if="selectedTab == 0 && isAdmin" />
			<client-user-management
				v-if="
					(selectedTab == 1 || (selectedTab == 0 && !isAdmin)) &&
					hasClient
				"
			/>
		</v-card>
	</div>
</template>
<script>
import AdminUserManagement from './AdminUserManagement.vue';
import ClientUserManagement from './ClientUserManagement.vue';
import { mapGetters } from 'vuex';
import { UserManagementActions } from '../../../store/actions';
import {
	UserManagementGetters,
	AuthGetterTypes,
	ClientContextGetters,
} from '../../../store/getters';

export default {
	components: {
		AdminUserManagement,
		ClientUserManagement,
	},
	name: 'userManagement',
	data() {
		return {
			initialized: false,
			tab: null,
			items: [
				{
					Name: 'Admin User Management',
					content: 'AdminUserManagement',
				},
				{
					Name: 'Client User Management',
					content: 'ClientUserManagement',
				},
			],
		};
	},
	computed: {
		...mapGetters({
			selectedTab: [UserManagementGetters.SELECTED_TAB],
			isAdmin: [AuthGetterTypes.IS_SUPERADMIN],
			hasClient: [ClientContextGetters.HAS_CLIENT],
		}),
	},
	mounted() {
		if (!this.isAdmin) {
			this.items.splice(0, 1);
		}
		this.tab = this.selectedTab;
		this.initialized = true;
	},
	destroyed() {},
	methods: {
		onTabItemChanged(e) {
			if (!this.initialized) return;
			this.$store.dispatch(UserManagementActions.LOAD_SELECTED_TAB, e);
		},
	},
};
</script>
